module.exports = __webpack_public_path__ + "img/point-icon.2d43413a.svg";